import React from "react";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

// Beispiel-Daten (z.B. monatliche Entwicklung von Projekten)
const data = [
   { name: "Januar", aktiv: 140, neu: 10, gescheitert: 2, verkauft: 20 },
   { name: "Februar", aktiv: 130,neu: 5,  gescheitert: 5, verkauft: 25 },
   { name: "März", aktiv: 145, neu: 11, gescheitert: 8, verkauft: 31 },
   { name: "April", aktiv: 125,neu: 8,  gescheitert: 3, verkauft: 25 },
   { name: "Mai", aktiv: 135,neu: 10,  gescheitert: 2, verkauft: 35 },
   { name: "Juni", aktiv: 120,neu: 6,  gescheitert: 5, verkauft: 30 },
];

const StatistikObjektUmsatz = () => {
   return (
      <div style={{ width: "100%", height: 600 }}>
         <ResponsiveContainer width="100%" height="100%">
            <AreaChart
               data={data}
               margin={{
                  top: 10,
                  right: 30,
                  left: 0,
                  bottom: 0,
               }}
            >
               {/* Hintergrund-Gitterlinien */}
               <CartesianGrid strokeDasharray="3 3" />

               {/* Achsenbeschriftung */}
               <XAxis dataKey="name" />
               <YAxis />

               {/* Interaktive Elemente */}
               <Tooltip />
               <Legend />

               {/* Die drei Kategorien - Wichtig: Identische stackId="1" bewirkt das Stapeln */}
               <Area type="monotone" dataKey="aktiv" stackId="1" stroke="#9284c7" fill="#9284c7" name="Aktiv" />
               <Area type="monotone" dataKey="neu" stackId="1" stroke="#0284c7" fill="#0284c7" name="Neu" />
               <Area
                  type="monotone"
                  dataKey="gescheitert"
                  stackId="1"
                  stroke="#ef4444"
                  fill="#ef4444"
                  name="Gescheitert"
               />
               <Area type="monotone" dataKey="verkauft" stackId="1" stroke="#22c55e" fill="#22c55e" name="Verkauft" />
            </AreaChart>
         </ResponsiveContainer>
      </div>
   );
};

export default StatistikObjektUmsatz;
